import { Component, ElementRef, HostListener, Input, ViewChild } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'custom-dropdown',
  templateUrl: './custom-dropdown.component.html',
  styleUrls: ['./custom-dropdown.component.scss'],
  animations: [
    trigger('dropdownAnimation', [
      state('closed', style({
        opacity: 0,
        height: '0px',
        visibility: 'hidden',
        transform: 'translateY(-20px)',
      })),
      state('open', style({
        opacity: 1,
        height: '*',
        visibility: 'visible',
        transform: 'translateY(0)',
      })),
      transition('closed <=> open', [
        animate('0.2s ease-out')
      ]),
    ])
  ]
})
export class CustomDropdownComponent {

  @Input() label: string = '';
  @Input() image: string = '';
  isDropdownOpen = false;

  @ViewChild('dropdownContainer') dropdownContainer!: ElementRef;

 protected toggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  @HostListener("document:click", ["$event"])
  onClickOutside(event: Event) {
    if (
      this.dropdownContainer &&
      !this.dropdownContainer.nativeElement.contains(event.target)
    ) {
      this.isDropdownOpen = false;
    }
  }
}
